import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'
import sizes from '../../theme/foundations/sizes'

export const buttonContainer = {
    display: 'flex',
    gap: pxToRem(5)
}

export const containerStyle = {
    width: {base: pxToRem(61), sm: pxToRem(61), md: pxToRem(72)},
    height: pxToRem(40),
    flexDirection: 'row',
    alignItems: 'center',
    border: '1px solid black',
    overflow: 'hidden',
    margin: 0,
    [`@media (max-width: ${sizes.container.md})`]: {
        height: pxToRem(35)
    }
}

export const buttonStyle = {
    color: 'black',
    bg: 'white',
    border: 'none',
    minW: 0,
    p: 0,
    _hover: {bg: 'white'},
    _active: {bg: 'white'},
    _focus: {boxShadow: 'none'},
    _disabled: {bg: 'white', color: 'gray.600', cursor: 'not-allowed'}
}

export const minusButtonStyle = {
    ...buttonStyle,
    w: {base: pxToRem(20), md: pxToRem(24)},
    h: '100%'
}

export const plusButtonStyle = {
    ...buttonStyle,
    w: {base: pxToRem(20), md: pxToRem(24)},
    h: '100%'
}

export const iconStyle = {
    color: 'currentColor',
    stroke: 'currentColor',
    strokeWidth: '2px',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    fill: 'none',
    w: {base: pxToRem(8), md: pxToRem(9)},
    h: {base: pxToRem(8), md: pxToRem(9)}
}

export const inputStyle = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    h: '100%',
    fontSize: pxToRem(14),
    p: 0,
    border: 'none',
    outline: 'none',
    focusBorderColor: 'transparent',
    _focus: {boxShadow: 'none'},
    fontFamily: fonts.primary,
    fontWeight: 400
}

export const flexStyle = {
    direction: 'row',
    align: 'flex-start',
    width: '100%',
    justify: {base: 'space-between', md: 'flex-start'},
    gap: 2
}

export const hStackStyle = {
    flex: '1',
    minW: 0,
    align: 'flex-start',
    alignItems: 'flex-start'
}

export const tagIconStyle = {
    w: pxToRem(16),
    h: pxToRem(16),
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    flex: 'none',
    mt: pxToRem(3)
}

export const calloutBoxStyle = {
    flex: '1',
    minW: 0,
    overflowWrap: 'break-word',
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: 400,
    color: 'cav_light_input_gray',
    lineHeight: 1.3,
    m: 0,
    '& a': {
        color: 'cav_light_input_gray',
        textDecoration: 'none',
        _hover: {
            color: 'red.cvs'
        }
    }
}

export const tooltipStyle = {
    bg: 'blackAlpha.650',
    color: 'white',
    borderRadius: 0,
    fontFamily: fonts.primary,
    fontSize: pxToRem(13),
    fontWeight: 400,
    placement: 'bottom-start'
}

export const desktopDetailsStyle = {
    ml: 2,
    textTransform: 'uppercase',
    fontSize: pxToRem(12),
    fontWeight: 500,
    color: 'cav_calltoaction_darkred',
    textDecoration: 'underline',
    cursor: 'pointer',
    display: {base: 'none', md: 'inline'}
}

export const mobileDetailsStyle = {
    textTransform: 'uppercase',
    fontSize: pxToRem(12),
    fontWeight: 500,
    color: 'cav_calltoaction_darkred',
    textDecoration: 'underline',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    display: {base: 'inline', md: 'none'},
    alignSelf: 'flex-start',
    flexShrink: 0,
    m: 0,
    mt: pxToRem(0.5)
}

export const stockLeftStyle = {
    marginBottom: '0',
    fontSize: pxToRem(14),
    fontFamily: fonts.primary,
    textTransform: 'uppercase',
    color: 'cav_faq_anchor_red',
    lineHeight: 'normal',
    letterSpacing: pxToRem(1)
}

export const storeAddressStyles = {
    '.radio': {
        display: 'flex',
        gap: pxToRem(32),
        '.chakra-radio__control[data-checked]': {
            background: 'none',
            backgroundColor: 'none',
            border: `${pxToRem(1)} solid black`
        },
        '.chakra-radio__control[data-checked]::before': {
            backgroundColor: 'black',
            margin: `${pxToRem(3)} auto`,
            height: pxToRem(8),
            width: pxToRem(8)
        },
        sapn: {
            margin: 0,
            display: 'flex',
            alignItems: 'center'
        },
        label: {
            alignItems: 'center',
            color: 'black',
            span: {
                fontSize: pxToRem(14),
                marginTop: 0,
                [`@media (min-width: ${sizes.container.md})`]: {
                    fontSize: pxToRem(16)
                }
            }
        },
        'span.chakra-radio__label': {
            marginLeft: pxToRem(10),
            [`@media (min-width: ${sizes.container.md})`]: {
                marginLeft: pxToRem(15)
            }
        },
        'span.chakra-radio__control': {
            border: `${pxToRem(1)} solid black`,
            height: pxToRem(12),
            width: pxToRem(12),
            [`@media (min-width: ${sizes.container.md})`]: {
                height: pxToRem(20),
                width: pxToRem(20)
            }
        }
    }
}
